const influencer_details = {
  "kayla_itsines": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Kayla_Itsines_B_W.webp?v=1708073297",
    "name": "Kayla Itsines",
    "title": "PT, Author & Entrepreneur",
    "bio": "Kayla is the co-founder and Head Trainer of the fitness app Sweat and has just published her latest book. As one of the most influential personal trainers in the world, her goal is to help women feel more confident and strong and support them on their health and fitness journey. Kayla has recently started incorporating Kiva’s Full Spectrum sauna into her recovery."
  },
  "scott_pendleburry": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Scott_P_Black_White.webp?v=1708073296",
    "name": "Scott Pendlebury",
    "title": "AFL Player",
    "bio": "Scott lives and breathes wellness throughout his professional and private life, so it only comes naturally that he jumps into the Kiva Wellness ice bath every morning before his ALF training at the Collingwood Football Club. Thanks to his strict health regime, he continues to defy age as one of the greatest Collingwood players ever."
  },
  "katherine_hay": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/image-asset.png?v=1708315319",
    "name": "Katherine Hay",
    "title": "Nutritionist",
    "bio": `<p>Katherine is qualified with a bachelor of health science majoring in nutritional medicine and is an accredited member of the Australian Natural Therapists Association, with over 7 years of clinical experience, she is changing the way her clients engage with food through her practice Kaptured Nutrition. She believes that there is no ‘one size fits all’ approach to health and everyone is extremely different, therefore each treatment plan is personalised with a realistic and non-restrictive approach. Katherines’ areas of expertise lie within reproductive health, preconception and post-natal care, fertility as well as gut health, mental health, skin and autoimmune conditions.</p>
    <p>After having her Kiva Wellness sauna for 5 months, she's noticed some amazing benefits, "I have loved incorporating weekly saunas into my routine as the positive effect for my mental health have been incredible" Katherine told us.</p>`
  },
  "morgan_mitchell": {
      "profile": "https:\/\/cdn.shopify.com\/s\/files\/1\/0601\/6647\/1855\/files\/Morgan_Mitchell_B_W.webp?v=1708073295",
      "name": "Morgan Mitchell",
      "title": "Olympian Athlete",
      "bio": "Morgan competes in the 800 metres and came 6th in the last Olympic Games. Being on top of her health is therefore of key relevance, that’s why having multiple sauna sessions per week help her with her exercise performance."
  },
  "luka_mccabe": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/DSC00122-2.png?v=1708315343",
      "name": "Luka McCabe",
      "title": "Midwife & Parenting Educator Extraordinaire",
      "bio": "Luka is a registered nurse, registered midwife and a CAPEA endorsed birth and parenting educator, as well as a certified nutrition consultant specialising in postpartum and babies. Mother to three, Luka started Boob To Food to help provide evidence based information to families who needed some support when it came to transitioning little ones from breastfeeding to solids. Luka is now the author of a widely popular book milk to meals, which is jam packed full of helpful recipes and resources that are designed to meet little ones nutritional needs."
  },
  "chontel_duncan": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Chontel_Duncan.jpg?v=1721708160",
      "name": "Chontel Duncan",
      "title": "Accredited Sports Nutritionist ",
      "bio": `<p>Chontel is an accredited sports nutritionist, fitness trainer and founder of the HIIT Station franchise. As a mother of 5 she knows how important self-care practices are, that's why she incorporates sauna and ice bath sessions regularly into her wellness routine, in particularly as part of her post-workout recovery.</p>

<p>“We’ve had the sauna for a bit and originally I started off doing it on my days off as part of my recovery, I then swapped to doing a session right after a workout and I can feel my increased blood flow doing it straight after a workout, it feels phenomenal. Also from an inflammation point of view, I don’t get sausage legs anymore after a workout, I can physically see that my body isn’t holding so much water anymore.” - Chontel Duncan</p>`
  },
  "emily_skye": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Emily_Skye.webp?v=1708073297",
      "name": "Emily Skye",
      "title": "Qualified Master Trainer & PT, International Model & Co-Founder of James Cosmetics",
      "bio": `Emily is a qualified personal trainer, with a Certificate IV in Fitness and Master Trainer qualification from the Australian Institute of Fitness. She is also a fitness model, qualified Beautician & Makeup Artist, and co-founder of James Cosmetics. With her busy career and 2 children she has to ensure that her own well-being doesn't come short. That's why Emily has been having regular sauna sessions every week and facilitated her sauna to recover from sport related injuries. 

“I’ve been doing the sauna sessions for several months now and I’ve never felt better than how I feel now. Combined with my training and nutritious food, I’m feeling the best that I have ever felt in my life since using the sauna.” - Emily Skye
`
  },
  "revie_jane": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Revie_Jane.webp?v=1708073297",
      "name": "Revie Jane",
      "title": "Entrepreneur & Owner of Athleisure Wear Label Alitah State",
      "bio": `<p>Revie Jane is a well-known entrepreneur on the Gold Coast scene. She has just launched athleisure label, Alitah State, with a focus on inclusivity and body positivity. </p>
  
  <p>She’s incorporated Kiva Wellness sauna sessions the last few months and told us, “I knew I would love having a sauna, I've wanted one for years but I didn't realise HOW MUCH I would love having a sauna. Having it accessible to our home has helped my sleep improve, increase my recovery for training and become a special part of my me-time.”</p>`
  },
  "ellie_watson": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Ellie_Watson_2.jpg?v=1721708160",
    "name": "Ellie Watson",
    "title": "Qualified Dietitian & Nutritionist, Business Owner & Author",
    "bio": "As a mum and dietitian, a wholesome life is part of Ellie’s natural routine. She’s the author of 3 best selling cookbooks."
  },
  "tanya_poppett": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Tanya_Poppett.webp?v=1708073297",
    "name": "Tanya Poppett ",
    "title": "Qualified Master Trainer & Fitness Coach",
    "bio": "Tanya is an Australian Master Trainer and Fitness Coach sharing her unique blend of Strength, HIIT, Maintenance and Mobility workouts with the world. Tanya’s qualifications include a Certificate 3 and 4 in Fitness, Master Trainer Level 1, and she has training in Pre and Post Natal."
  },
  "tino_fa": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Tino_Fa.jpg?v=1721708160",
    "name": "Tino Fa'asuamaleaui",
    "title": "Rugby League Footballer",
    "bio": "Tino is the captain of the Gold Coast Titans and has played for Samoa and Australia at international level."
  },
  "chad_hurst": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Chad_Hurst_480x480.webp?v=1708073297",
    "name": "Chad Hurst",
    "title": "International Model, TV Personality & Fitness Coach",
    "bio": `<p>Chad is an internationally acclaimed model, TV personality and fitness coach with his own training facility in Sydney. He has trained Muay Thai and boxing, mastering different techniques during his time in Thailand and America.</p>
    <p>His passion and focus lies in mental health and weight loss, as he believes that a positive mindset is the best result in itself.</p>`
  },
  "dani_guy": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/5_B_W.png?v=1708306181",
    "name": "Dani Guy",
    "title": "Qualified Nutritionist",
    "bio": `<p>Danielle is a qualified nutritionist and all about body positivity, health and wellness with a special interest in post-partum fitness.</p>
    <p>As a mother of 3 young kids she wants to set a good example of living a healthy lifestyle. Suffering from bowel disease and arthritis, Dani incorporates Kiva Wellness sauna sessions frequently into her daily wellness.</p>
    <p>“I’m literally obsessed. Using it every night and it’s been the best for me in terms of recovery with training and how much better I’m sleeping.” - Dani Guy</p>`
  },
  "emma_maidment": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Emma_Maidment.webp?v=1708073297",
    "name": "Emma Maidment",
    "title": "Internationally Renowned Yoga & Meditation Teacher, Writer & Podcaster",
    "bio": "Emma is an internationally renowned yoga and meditation teacher, writer and podcaster. Known for her empowering and uplifting manner of educating, and sharing the science of yoga and meditation in a fun and accessible way. After the birth of her second baby, she is using our infrared sauna as a post-partum recovery and meditation tool. "
  },
  "khan_porter": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/khan_porter_B_W.webp?v=1708073296",
    "name": "Khan Porter",
    "title": "Athlete",
    "bio": "A 7 times CrossFit Games veteran and a recent Gladiator, Khan Porter has remained one of Australia’s leading athletes who not only focuses on physical fitness but is also a strong advocate for mental health. A former state rugby player and national surf lifesaver, Khan incorporates Kiva ice bath sessions in his daily physical and mental recovery."
  },
  "james_newbury": {
    "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/James_Newbury_B_W.jpg?v=1721708159",
    "name": "James Newbury",
    "title": "Athlete",
    "bio": "A former semi professional rugby player for the Queensland and Sydney Rugby League, James is a 4 times CrossFit Games Athlete who incorporates ice baths before his CrossFit training sessions that speed up his muscle recovery."
  },
  "millie_marshall": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Millie_Marshall_B_W.webp?v=1708073296",
      "name": "Millie Marshall",
      "title": "Fitness Coach",
      "bio": "After overcoming an eating disorder, Millie spent years educating herself about all things fitness, nutrition, and health. She’s one of Australia’s most successful online fitness coaches, who teaches her clients how to achieve their goals in a healthy, sustainable and empowering way."
  },
  "molly_picklum": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Molly_Picklum.png?v=1728535192",
      "name": "Molly Picklum",
      "title": "Surfer",
      "bio": "Picklum is an Australian professional surfer, ranked fifth in the world after her 2023 season finish. She’s had back-to-back Australian Championship wins and was named Female Rising Star at the 2020 Australian Surfing Awards. Being a professional surfer, who is always jet setting across the world, ways to improve her recovery are of key importance to Molly."
  },
  "bree_masters": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Bree_Masters.webp?v=1716439561",
      "name": "Bree Masters",
      "title": "Sprinter",
      "bio": "Masters is an Australian sprinter. At the world championships in 2022 she set the fastest time by an Aussie at a Global (Worlds/Olympics) meet for 15 years. Two weeks later at the Commonwealth Games she made the 100m semi-final and ran second leg on the relay team which placed fourth. Bree has been using the Circadian Sleep Pod to enhance her recovery and training."
  },
  "touk_miller": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Touk_Miller.webp?v=1716439561",
      "name": "Touk Miller",
      "title": "AFL Player",
      "bio": "Miller is an AFL player, who joined the Gold Coast SUNS in 2014 and has served as captain since 2022. Having played over 150 games for the Gold Coast SUNS, Touk takes his recovery, health and wellness seriously."
  },
  "annabelle_ronfeldt": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Annabelle_Ronfeldt.webp?v=1716439561",
      "name": "Annabelle Ronfeldt",
      "title": "Athlete",
      "bio": "Ronfeldt is an Australian athlete and coach at ‘Move with Us’. She prioritises health and wellbeing and incorporates wellness such as with sauna sessions to further expand her mind, body and spirit."
  },
  "jacinta_beecher": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Jacinta_Beecher.webp?v=1716439561",
      "name": "Jacinta Beecher",
      "title": "Sprinter",
      "bio": "Beecher is an Australian 200m sprinter and participated in the 2022 Commonwealth Games and World Athletics Championships."
  },
  "elly_miles": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Elly_Miles.webp?v=1716439561",
      "name": "Elly Miles",
      "title": "TV Personality",
      "bio": "Miles is an Australian TV Personality, best known as The Bachelorette 2019. She stays active and healthy as part of her daily routine and incorporating sauna sessions has become an essential."
  },
  "dani_king": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Dani_King.webp?v=1716439561",
      "name": "Dani King",
      "title": "Model",
      "bio": "A mother, wife, model and yogi, Dani has become a source of daily inspiration in her search for a healthy lifestyle."
  },
  "kwame_duah": {
      "profile": "https://cdn.shopify.com/s/files/1/0601/6647/1855/files/Kwame_Duah.webp?v=1716439561",
      "name": "Kwame Duah",
      "title": "Personal Trainer",
      "bio": "Duah is an Australian Personal Trainer and a World Champion professional Natural Bodybuilder, who was recently on the hit series ‘Gladiators’."
  }
  
}

let is_modal_open = false;


// influencer banner logic start
const imageGridElem  = document.querySelector('#influencer-banner .image-grid') 
const isBanner = !!imageGridElem

function loadInfluencerBannerImages(){
  let cards = ''
  for (const [key, influencer] of Object.entries(influencer_details)) {
     cards += 
     `<div class="relative influencer-card">
        <div class="influencer-banner__card-overlay">
            <p class="influencer-banner__name text-white font-bold">
              ${influencer.name}
            </p>
        </div>
        <img src="${influencer.profile}" class="image influencer__img" width="400" height="400" alt="${influencer.name}" data-key="${key}"/>
      </div>
     `
  }

  imageGridElem.innerHTML = cards
  imageGridElem.style.gridTemplateColumns = `repeat(${Object.entries(influencer_details).length}, 1fr)`
}

function pauseAnimation(){
  imageGridElem.style.animationPlayState = 'paused';
}
  
function playAnimation(){
  imageGridElem.style.animationPlayState = 'running';
}

if(isBanner){
  imageGridElem.addEventListener('mouseenter', pauseAnimation)
  imageGridElem.addEventListener('mouseleave', () => {
    if (!is_modal_open){
      playAnimation()
    }
  })
}
// influencer banner logic end 

//influencer grid logic end
const influencerGridElem = document.getElementById('influencer-grid')

function loadInfluencersCard(){
  let cards = ''
  for (const [key, influencer] of Object.entries(influencer_details)) {
     cards += 
     `<div class="relative influencer-card">
        <img src="${influencer.profile}" class="image influencer__img" width="400" height="400" alt="${influencer.name}" data-key="${key}"/>
        <div class="influencer-card__details">
          <h5>${influencer.name}</h5>
          <p>${influencer.title}</p>
        </div>
      </div>
     `
  }
  influencerGridElem.innerHTML = cards
}

//influencer grid logic end

if (isBanner){
  loadInfluencerBannerImages()
}else{
  loadInfluencersCard()
}

function closeModal(){
  const modal = document.getElementsByClassName("influencer-modal")[0]
  if(modal){
    document.body.removeChild(modal)
    if(isBanner){
      playAnimation();
    }
    is_modal_open = false;
  }
}

function openModal(key){
  const elem = document.createElement('div')
  const influencer = influencer_details[key]

  if(!influencer) return 
  
  elem.classList.add("influencer-modal")
  elem.innerHTML = 
  `
  <style>      
    .influencer-modal{
      position: fixed;
      z-index: 9999;
      inset: 0;
      display: flex;
      align-items:center;
      justify-content: center;
      background: #00000050;
    }
  
   .influencer-modal > div{
      width: min(95vw,1024px);
      max-height: min(80vh,650px);
      overflow-y: auto;
      background: white;
      padding: 32px;
  }

    .influencer-modal__close-btn{
      position: absolute;
      top: 16px;
      right: 16px;
    }

    .gap-4{
      gap:16px;
    }
    
    .gap-8{
      gap: 32px;
    }

    .influencer-modal .btn{
      width: fit-content;
    }
    
    .influencer-modal__name{
      font-size: 24px;
      color: var(--ember);
      font-weight: 700;
    }
    
    .influencer-modal__title{
      font-weight: 700;
    }

    @media (min-width:768px){
      .influencer-modal > div{
            padding: 64px;
        }

       .influencer-modal__image{
          width: 50%;
          max-width: 500px;
      }
      .influencer-modal__name{
        font-size: 24px;
      }
    }
  </style>
  <div class="flex flex-col md:flex-row items-center gap-8 relative">
    <button class="influencer-modal__close-btn">
        <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.7813 12.5313L20.4688 20.2188M20.4688 12.5313L12.7813 20.2188M32 16.375C32 18.3941 31.6023 20.3934 30.8296 22.2588C30.057 24.1241 28.9245 25.8191 27.4968 27.2468C26.0691 28.6745 24.3741 29.807 22.5088 30.5796C20.6434 31.3523 18.6441 31.75 16.625 31.75C14.6059 31.75 12.6066 31.3523 10.7412 30.5796C8.87586 29.807 7.18093 28.6745 5.75323 27.2468C4.32553 25.8191 3.19302 24.1241 2.42035 22.2588C1.64769 20.3934 1.25 18.3941 1.25 16.375C1.25 12.2973 2.86986 8.38661 5.75323 5.50323C8.6366 2.61986 12.5473 1 16.625 1C20.7027 1 24.6134 2.61986 27.4968 5.50323C30.3801 8.38661 32 12.2973 32 16.375Z" stroke="var(--ember)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
      <img src="${influencer.profile}" class="influencer-modal__image" width="400" height="400" alt="${influencer.name}"/>
    <div class="influencer-modal__left-section flex flex-col gap-4">
      <div>
        <h4 class="influencer-modal__name">
          ${influencer.name}
        </h4>
        <p class="influencer-modal__title">
          ${influencer.title}
        </p>
      </div>
      <div>
        ${influencer.bio}
      </div>
    </div>
  </div>
  `
  document.body.appendChild(elem)
  is_modal_open = true;
  const closeBtn = document.querySelector('.influencer-modal__close-btn')

  closeBtn.addEventListener('click', closeModal)
}

const cards = document.querySelectorAll('.influencer-card')
cards.forEach((card) => {
  const img = card.querySelector('img')
   card.addEventListener('click', function(){
      const key = img.getAttribute("data-key")
      openModal(key)
      if(isBanner){
        pauseAnimation()
      }
   })
})